import { useEffect, useState } from "react";

import { AfterTrialPopupLoader } from "app/pages/digital-suite/home-page/components/AfterTrialPopup/AfterTrialPopupLoader";
import { getPackages } from "app/pages/digital-suite/home-page/components/AfterTrialPopup/getPackages";
import type { IPackagesPrice } from "app/pages/digital-suite/home-page/components/AfterTrialPopup/types";

import { AfterTrialHookPopup } from "./AfterTrialHookPopup";

export const AfterTrialHookContainer = () => {
    const [packages, setPackages] = useState<IPackagesPrice | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            const response = await getPackages();
            if (response?.PackagesPrices) {
                setPackages(response.PackagesPrices);
            }
        };
        void fetchData();
    }, []);

    return packages ? <AfterTrialHookPopup packages={packages} /> : <AfterTrialPopupLoader />;
};
